import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'common-cloudstudio';
import { CustomMapComponent } from './custom-map/custom-map.component';
import { AlarmsMapComponent } from './alarms-map/alarms-map.component';


const routes: Routes = [
 /*  { path: '', component: MapTabsComponent, canActivate: [AuthGuard]}, */
  { path: 'alarms', component: AlarmsMapComponent, canActivate: [AuthGuard]},
  { path: 'custom/:id', component: CustomMapComponent, canActivate: [AuthGuard]},
];


export const mapRoutes = RouterModule.forChild(routes);